// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1RU3w","info":"UpdateTermsInfo_info__1Z8qW"};